const RANDOM_MAX_NUMBER = 100000000;

export const generateUniqueId = () => {
  const random = Math.floor(Math.random() * (RANDOM_MAX_NUMBER - 1) + 1);

  return `id-${Date.now()}-${random}`;
};
